module.exports = __webpack_public_path__ + "static/media/nodejs.edb37b2d.png";